export default __webpack_public_path__ + "static/media/banner3.c0d53e22.jpg";